// src/pages/AboutPage.js
import React from "react";
import "./SimplePage.css";

export default function AboutPage() {
  return (
    <div className="simple-page">
      <div className="section" style={{paddingTop:"8rem"}}>
        <div className="simple-header">
          <span className="section-eyebrow">創設者 · Les Fondateurs</span>
          <h1 className="section-title">Les Âmes<br/>Damnées</h1>
          <div className="divider"/>
        </div>

        <div className="founders-grid">
          <div className="founder-card">
            <div className="founder-kanji">絵</div>
            <p className="founder-role">ARTISTE VAGABONDE</p>
            <h2 className="founder-name">NAYTH</h2>
            <p className="founder-bio">
              Elle dessine les démons à la main. Chaque trait d'encre est une colère retenue, une raquette pas cassée, un cri rentré.
              Nayth capture ce que les mots du ping ne peuvent pas dire — la grimace, la posture, l'énergie bestiale du joueur en transe compétitive.
            </p>
            <p className="founder-bio" style={{marginTop:"1rem"}}>
              Ses templates dessinés main sont la base de chaque avatar Takkyu Oni. Elle ne joue pas au ping. Elle observe. C'est pire.
            </p>
          </div>

          <div className="founder-card">
            <div className="founder-kanji">鬼</div>
            <p className="founder-role">DÉMON EN CHEF</p>
            <h2 className="founder-name">AINO</h2>
            <p className="founder-bio">
              Aino est le démon. Pas la métaphore — vraiment. Il a passé trop d'années dans des salles de ping à accumuler les défaites serrées,
              les filets chanceux de l'adversaire, les manierisms des autres, pour ne pas finir par incarner quelque chose de démoniaque.
            </p>
            <p className="founder-bio" style={{marginTop:"1rem"}}>
              C'est lui qui a catégorisé les archétypes. Qui a nommé les Oni. Qui connaît exactement à quelle vitesse la rage monte dans un set décisif.
              Il vit dedans.
            </p>
          </div>
        </div>

        <div className="brand-manifesto">
          <p className="manifesto-text">
            Takkyu Oni n'est pas une marque de sport. C'est un <span>miroir</span>.
            On fabrique du life wear pour les gens qui savent exactement quel démon habite leur revers,
            leur service, leur gestion du score serré.
            Porter un Takkyu Oni c'est dire : <span>j'assume mes vices du ping</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
